import styled from "styled-components";

export const HomeBasedLikeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
`;
